import React from 'react'
import { Button, Grid, TextField, Typography } from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import colors from '../../../../assets/colors'
import { dateFormatedFullDate, renderRoute } from '../../../../util/utils'

const InfoLine = ({ label, value, ...rest }) => (
  <Grid item xs={12} {...rest}>
    <Typography style={{ color: colors.textGray }}>
      {label}: {value || '-'}
    </Typography>
  </Grid>
)

function TimeModalInfo({
  open,
  info,
  handleClose,
  items,
  setHoverId,
  updateChildren,
}) {
  const permissions = useSelector(state => state.auth.permissions)
  const location = useLocation()
  const classes = filterStylesComponents()

  // O índice precisa ser o da lista original: `updateChildren` altera
  // `form.services[index]`, então usar o índice de uma lista filtrada
  // gravaria a etiqueta no item errado.
  const index = info ? (items ?? []).findIndex(item => item.id == info) : -1
  const item = index >= 0 ? items[index] : null

  const buildDates = () => {
    if (item?.measureType?.id === 1) {
      return (
        <>
          <InfoLine
            label="Início do Serviço"
            value={dateFormatedFullDate(item?.attendance_started_at)}
          />
          <InfoLine
            label="Fim do Serviço"
            value={dateFormatedFullDate(item?.attendance_ended_at)}
          />
        </>
      )
    }

    return (
      <>
        <InfoLine
          label="Data de coleta"
          value={dateFormatedFullDate(item?.attendance_started_at)}
        />
        <InfoLine
          label="Data de entrega"
          value={dateFormatedFullDate(item?.devolution_started_at)}
        />
      </>
    )
  }

  function getAttendantName() {
    if (item?.devolution_started_at) {
      return item?.devolution_attendant?.name
    }

    return item?.attendant?.name
  }

  const getIsClientService = () => {
    const { attendanceType = {}, serviceType = {} } = item || {}

    if (!attendanceType?.id && serviceType?.attendance_type_id == 1)
      return false
    if (attendanceType?.id && attendanceType?.id == 1) return false

    return true
  }

  const serviceId = item?.service_id || items?.[0]?.service_id

  return (
    <BaseFilterModal
      open={open}
      title="Informações do Item"
      hiddenHelpButton
      handleOpen={handleClose}
    >
      <Grid item xs={12} style={{ width: '320px' }}>
        <Grid container spacing={2}>
          {item && (
            <>
              <InfoLine label="Serviço" value={item?.serviceType?.name} />

              {/* remover quando tipo de atendimento for no cliente */}
              {!getIsClientService() && (
                <Grid item xs={12}>
                  {renderRoute(['update-bar-code'], permissions) &&
                  item.service_id ? (
                    <TextField
                      value={item.bar_code || ''}
                      onChange={event => {
                        updateChildren(index, event.target.value, 'bar_code')
                      }}
                      label="Etiqueta"
                      placeholder="Etiqueta..."
                      variant="standard"
                      fullWidth
                    />
                  ) : (
                    <Typography style={{ color: colors.textGray }}>
                      Etiqueta: {item.bar_code || '-'}
                    </Typography>
                  )}
                </Grid>
              )}

              <InfoLine label="Atendente" value={getAttendantName()} />

              {buildDates()}

              {item?.times && (
                <>
                  <InfoLine
                    label="Começou em"
                    value={dateFormatedFullDate(item?.times?.started_at)}
                  />
                  <InfoLine
                    label="Finalizou em"
                    value={dateFormatedFullDate(item?.times?.ended_at)}
                  />
                </>
              )}

              {item?.restoration_item_id ? (
                <InfoLine
                  label="Tapete de restauração"
                  value={item?.item_restored?.bar_code}
                  onMouseEnter={() => setHoverId(item?.item_restored?.bar_code)}
                  onMouseLeave={() => setHoverId(null)}
                />
              ) : (
                ''
              )}
            </>
          )}

          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              onClick={handleClose}
              className={classes.btnAdd}
              aria-label="finance"
              component={Link}
              to={{
                pathname: `/calendar/${serviceId}`,
                search: `?os=${serviceId}`,
                state: { from: `${location.pathname}${location.search}` },
              }}
              disabled={!serviceId}
            >
              Reagendar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default React.memo(TimeModalInfo)
